
import {surveyAnswerRegisterState, surveyRegisterState} from "@/stores/survey/atom";

export const surveyState = {
  surveyRegisterState,
  surveyAnswerRegisterState
}